// Browser-side Ed25519 keypair generation for the dashboard
// registered-key flow (PR 15-B). This is the only module that depends on
// @noble/curves; the PEM encoding it calls lives in the dependency-free
// pem.ts. We use @noble rather than WebCrypto Ed25519 so key generation
// does not depend on browser-version support (Approach A in the plan).
// The private key never leaves the browser: it is shown once for the
// customer to download and is discarded when the create dialog closes.
import { ed25519 } from "@noble/curves/ed25519.js";
import { encodeEd25519SpkiPem, encodeEd25519Pkcs8Pem } from "./pem";

export type GeneratedKeypair = {
  publicKeyPem: string;
  privateKeyPem: string;
};

// Generate an Ed25519 keypair and return both halves as canonical PEM.
// publicKeyPem is the SPKI PEM submitted to the dashboard API as
// agent_public_key; privateKeyPem is the PKCS8 PEM the customer downloads
// and feeds to the SDK.
export function generateEd25519Keypair(): GeneratedKeypair {
  const secretKey = ed25519.utils.randomSecretKey();
  const publicKey = ed25519.getPublicKey(secretKey);
  return {
    publicKeyPem: encodeEd25519SpkiPem(publicKey),
    privateKeyPem: encodeEd25519Pkcs8Pem(secretKey)
  };
}
